import { fetch } from '@/api/mock/mockApiUtils';
import representasjoner from './data/representasjoner.json';
import driftsmeldingData from './data/driftsmeldingData.json';
import abonnementerData from './data/abonnementerData.json';
import abonnementstyperData from './data/abonnementstyperData.json';
import abonnementByTypeData from './data/abonnementByTypeData.json';
import startAbonnementKvitteringData from './data/startAbonnementKvitteringData.json';
import folkeregistrertAdresseDetaljerData from './data/folkeregistrertAdresseDetaljerData.json';
import alleEideEiendommerData from './data/alleEideEiendommerData.json';
import eiendomsdetaljerByGBS1 from './data/eiendomsdetaljerByGBS1.json';
import eiendomsdetaljerByGBS2 from './data/eiendomsdetaljerByGBS2.json';
import eiendomsdetaljerByGBS3 from './data/eiendomsdetaljerByGBS3.json';
import eiendomsdetaljerByGBS4 from './data/eiendomsdetaljerByGBS4.json';
import eiendomsdetaljerByGBS5 from './data/eiendomsdetaljerByGBS5.json';
import eiendomsdetaljerByGBSDefault from './data/eiendomsdetaljerByGBSDefault.json';

import avfallOgGjenvinningMockApi from './avfallOgGjenvinning/avfallOgGjenvinningMockApi';

export default {
  getRepresentations() {
    return fetch(representasjoner);
  },
  getDriftsmeldinger() {
    return fetch(driftsmeldingData);
  },
  getAbonnementer() {
    return fetch(abonnementerData);
  },
  getAbonnementByType() {
    return fetch(abonnementByTypeData);
  },
  startAbonnement() {
    return fetch(startAbonnementKvitteringData);
  },
  updateAbonnement() {
    return fetch({ status: 'OK' });
  },
  stopAbonnement() {
    return fetch({ status: 'OK' });
  },
  getAbonnementstyper() {
    return fetch(abonnementstyperData, 1000);
  },
  getDetaljerOmFolkeregistrertAdresse() {
    return fetch(folkeregistrertAdresseDetaljerData);
  },
  getAlleBrukersEideEiendommer() {
    return fetch(alleEideEiendommerData);
  },
  getEiendomsdetaljerByGBS(gbs) {
    const { gardsnr } = gbs;
    const { bruksnr } = gbs;
    const { seksjonsnr } = gbs;
    if (gardsnr === 215 && bruksnr === 156 && seksjonsnr === 21) {
      return fetch(eiendomsdetaljerByGBS1);
    }
    if (gardsnr === 321 && bruksnr === 127 && seksjonsnr === 2) {
      return fetch(eiendomsdetaljerByGBS2);
    }
    if (gardsnr === 78 && bruksnr === 99 && seksjonsnr === 23) {
      return fetch(eiendomsdetaljerByGBS3);
    }
    if (gardsnr === 78 && bruksnr === 99 && seksjonsnr === null) {
      return fetch(eiendomsdetaljerByGBS4);
    }
    if (gardsnr === 28 && bruksnr === 125 && seksjonsnr === null) {
      return fetch(eiendomsdetaljerByGBS5);
    }
    return fetch(eiendomsdetaljerByGBSDefault);
  },

  ...avfallOgGjenvinningMockApi,
};
